module.exports = __webpack_public_path__ + "img/pointing.3e750d0a.png";